module.exports = __webpack_public_path__ + "Server-Disabled.Ssh.4fdc4620231e932df45de3e658cafb5a.hashedasset.svg";